import getMallErrorMessage from "@saleor/utils/errors/mall";

export function useValidation(initialForm) {
  const {
    city,
    code,
    contactPerson,
    email,
    latitude,
    longitude,
    mallClosing,
    mallOpening,
    mobileNo,
    name,
    provinceCode,
    serviceArea,
    smMarketExternalCode,
    smMarketExternalId,
    smMarketExternalName,
    telephoneNo,
    totalLandArea
  } = initialForm;
  const smMarketExternalNameMessage = () => {
    if (
      (smMarketExternalId !== "" && smMarketExternalId !== null) ||
      smMarketExternalCode !== ""
    ) {
      if (smMarketExternalName === "") {
        return "This field should not be empty";
      }
    }
    return null;
  };
  const smMarketExternalIdMessage = () => {
    if (smMarketExternalCode !== "" || smMarketExternalName !== "") {
      if (smMarketExternalId === null || smMarketExternalId === "") {
        return "This field should not be empty";
      }
    }
    return null;
  };
  const smMarketExternalCodeMessage = () => {
    if (
      (smMarketExternalId !== null && smMarketExternalId !== "") ||
      smMarketExternalName !== ""
    ) {
      if (smMarketExternalCode === "") {
        return "This field should not be empty";
      }
    }
    return null;
  };

  const codeMessage = () => {
    if (code === "") {
      return "This field should not be empty";
    }
    return null;
  };
  const contactPersonMessage = () => {
    if (contactPerson === "") {
      return "This field should not be empty";
    }
    return null;
  };
  const emailMessage = () => {
    const pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    if (email === "") {
      return "This field should not be empty";
    } else if (!pattern.test(email)) {
      return "Enter a valid email address.";
    }
    return null;
  };
  const latitudeMessage = () => {
    if (latitude === "") {
      return "This field should not be empty";
    }

    return null;
  };
  const longitudeMessage = () => {
    if (longitude === "") {
      return "This field should not be empty";
    }

    return null;
  };

  const mallClosingMessage = () => {
    if (mallClosing === "") {
      return "This field should not be empty";
    }
    return null;
  };
  const mallOpeningMessage = () => {
    if (mallOpening === "") {
      return "This field should not be empty";
    }
    return null;
  };
  const mobileNoMessage = () => {
    const mobileNumberWithoutSpaces = mobileNo.replace(/\s+/g, ""); // Spaces generated by libphonenumber are removed here

    if (mobileNumberWithoutSpaces === "") {
      return "This field should not be empty";
    }
    if (mobileNumberWithoutSpaces.length > 11) {
      return "Invalid Mobile Number";
    }
    if (mobileNumberWithoutSpaces.length < 11) {
      return "Length should be 11 digits";
    }
    return null;
  };
  const nameMessage = () => {
    if (name === "") {
      return "This field should not be empty";
    }
    return null;
  };
  const serviceAreaMessage = () => {
    if (serviceArea === "") {
      return "This field should not be empty";
    }

    return null;
  };
  const telephoneNoMessage = () => {
    const telephoneNumberWithoutSpaces = telephoneNo.replace(/\s+/g, ""); // Spaces generated by libphonenumber are removed here

    if (telephoneNumberWithoutSpaces === "") {
      return "This field should not be empty";
    }
    return null;
  };
  const totalLandAreaMessage = () => {
    if (totalLandArea === "") {
      return "This field should not be empty";
    }

    return null;
  };

  const cityMessage = () => {
    if (city === "") {
      return "This field should not be empty";
    }

    return null;
  };
  const provinceCodeMessage = () => {
    if (provinceCode === "") {
      return "This field should not be empty";
    }

    return null;
  };

  return {
    city: cityMessage(),
    code: codeMessage(),
    contactPerson: contactPersonMessage(),
    email: emailMessage(),
    latitude: latitudeMessage(),
    longitude: longitudeMessage(),
    mallClosing: mallClosingMessage(),
    mallOpening: mallOpeningMessage(),
    mobileNo: mobileNoMessage(),
    name: nameMessage(),
    provinceCode: provinceCodeMessage(),
    serviceArea: serviceAreaMessage(),
    smMarketExternalCode: smMarketExternalCodeMessage(),
    smMarketExternalId: smMarketExternalIdMessage(),
    smMarketExternalName: smMarketExternalNameMessage(),
    telephoneNo: telephoneNoMessage(),
    totalLandArea: totalLandAreaMessage()
  };
}

export const checkError = (key, formErrors, validationError, intl) => ({
  hasError: !!formErrors[key] || !!validationError[key],
  message: formErrors[key]
    ? getMallErrorMessage(formErrors.oldPassword, intl)
    : validationError[key]
});

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
